// Google Places Autocomplete for Easify Product Form
(function() {
  console.log('Easify Google Places Autocomplete - Direct Injection');
  
  // Google Places API key - Client's properly configured key
  const API_KEY = 'AIzaSyC5BXnKsj8WxxOjC8VBOMFAuYZjMSspHUU';
  const OPTION_ID = 342431; // From console logs
  
  // Function to initialize Google Places on an input
  function initializeGooglePlacesForInput(input) {
    if (!input) return false;
    
    try {
      console.log('Initializing Google Places for input:', input);
      
      // Create the autocomplete object
      const autocomplete = new google.maps.places.Autocomplete(input, {
        types: ['establishment'],
        fields: ['place_id', 'name', 'formatted_address', 'geometry']
      });
      
      // Set placeholder
      input.setAttribute('placeholder', 'Tapez le nom de votre entreprise ici');
      
      // When a place is selected
      autocomplete.addListener('place_changed', function() {
        const place = autocomplete.getPlace();
        if (!place.geometry) return;
        
        console.log('Selected place:', place.name, place.formatted_address);
        
        // Update the input value to include the full address
        input.value = `${place.name}, ${place.formatted_address}`;
      });
      
      console.log('Google Places Autocomplete initialized successfully');
      return true;
    } catch (error) {
      console.error('Error initializing Google Places Autocomplete:', error);
      return false;
    }
  }
  
  // Fix the syntax error in custom.js
  try {
    // Find all fetch calls that might have the syntax error
    const scripts = document.querySelectorAll('script:not([src])');
    scripts.forEach(script => {
      if (script.textContent && script.textContent.includes('if(response.ok){') && 
          script.textContent.includes('throw ""')) {
        console.log('Found script with potential syntax error, attempting to fix...');
        const fixedContent = script.textContent.replace(
          /if\(response\.ok\)\{\s*return response\.json\(\)\s*\}\s*throw\s*""/g, 
          'if(response.ok){return response.json();}else{throw new Error("Response not OK");}'
        );
        if (fixedContent !== script.textContent) {
          const newScript = document.createElement('script');
          newScript.textContent = fixedContent;
          script.parentNode.replaceChild(newScript, script);
          console.log('Fixed syntax error in inline script');
        }
      }
    });
  } catch (e) {
    console.log('Error trying to fix syntax error:', e);
  }
  
  // Load Google Maps API script
  function loadGoogleMapsAPI() {
    if (window.google && window.google.maps && window.google.maps.places) {
      console.log('Google Maps API already loaded');
      initGooglePlaces();
      return;
    }
    
    console.log('Loading Google Maps API with properly configured key...');
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&libraries=places&callback=initGooglePlacesForEasify`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }
  
  // Initialize Google Places Autocomplete
  window.initGooglePlacesForEasify = function() {
    console.log('Google Maps API loaded, initializing Places Autocomplete');
    
    // Try a very direct approach first - from the screenshot we can see the exact field
    const directInput = document.querySelector('input[type="text"][placeholder="Tapez le nom de votre entreprise ici"]');
    if (directInput) {
      console.log('Found input directly by placeholder after API load');
      initializeGooglePlacesForInput(directInput);
      return;
    }
    
    // If not found directly, try to find it by its label
    const requiredField = document.querySelector('.field-error, .error-message, [class*="error"]');
    if (requiredField && requiredField.textContent.includes('required')) {
      const container = requiredField.closest('div, form, section');
      if (container) {
        const input = container.querySelector('input[type="text"]');
        if (input) {
          console.log('Found input by required field error');
          initializeGooglePlacesForInput(input);
          return;
        }
      }
    }
    
    // If still not found, try the regular approach
    initGooglePlaces();
  };
  
  // Find and enhance the Easify input field
  function initGooglePlaces() {
    // Try to find the input field
    findEasifyInput(function(input) {
      if (!input) {
        console.log('Could not find Easify input field');
        return;
      }
      
      console.log('Found Easify input field:', input);
      
      // Initialize Google Places Autocomplete using the shared function
      initializeGooglePlacesForInput(input);
    });
  }
  
  // Find the Easify input field
  function findEasifyInput(callback) {
    console.log('Looking for Easify input field...');
    
    // Direct approach - from the screenshot we can see the input field is visible
    // Look for input field with placeholder "Tapez le nom de votre entreprise ici"
    const inputByPlaceholder = document.querySelector('input[placeholder*="entreprise"], input[placeholder*="Tapez"]');
    if (inputByPlaceholder) {
      console.log('Found input by placeholder');
      callback(inputByPlaceholder);
      return;
    }
    
    // Look for the field that has "Recherchez votre entreprise pour vous installer" label
    const labels = document.querySelectorAll('label, .label, div, span');
    for (const label of labels) {
      if (label.textContent && label.textContent.includes('Recherchez votre entreprise')) {
        console.log('Found label with "Recherchez votre entreprise"');
        // Find the closest input field
        const container = label.closest('.product-form__item, .form-field, .option-wrapper, [class*="easify"]');
        if (container) {
          const input = container.querySelector('input[type="text"]');
          if (input) {
            console.log('Found input field near the label');
            callback(input);
            return;
          }
        }
      }
    }
    
    // Try to find by option ID
    const selectors = [
      `[data-option-id="${OPTION_ID}"] input[type="text"]`,
      `[data-option-set-id="${OPTION_ID}"] input[type="text"]`,
      `[data-easify-option-id="${OPTION_ID}"] input[type="text"]`,
      '[data-option-name="Google Plaques"] input[type="text"]',
      '[data-option-name="Recherchez votre entreprise pour vous installer"] input[type="text"]'
    ];
    
    // Try each selector
    for (const selector of selectors) {
      try {
        const input = document.querySelector(selector);
        if (input) {
          console.log(`Found input with selector: ${selector}`);
          callback(input);
          return;
        }
      } catch (error) {
        console.log(`Error with selector ${selector}:`, error.message);
      }
    }
    
    // From the screenshot, we can see the input field is visible on the page
    // Look for any input field that might be for business search
    console.log('Trying broader approach to find input field');
    
    // Look for any text input with a required field message
    const errorMessages = document.querySelectorAll('.field-error, .error-message, [class*="error"], [class*="required"]');
    for (const errorMsg of errorMessages) {
      if (errorMsg.textContent && errorMsg.textContent.includes('required')) {
        console.log('Found error message about required field');
        const container = errorMsg.closest('.product-form__item, .form-field, .option-wrapper, [class*="easify"]');
        if (container) {
          const input = container.querySelector('input[type="text"]');
          if (input) {
            console.log('Found input field near error message');
            callback(input);
            return;
          }
        }
      }
    }
    
    // If not found, look for any text input with relevant context
    const allInputs = document.querySelectorAll('input[type="text"]');
    for (const input of allInputs) {
      const parent = input.closest('.product-form__item, .form-field, .option-wrapper, [class*="easify"]');
      if (parent) {
        const parentText = parent.textContent.toLowerCase();
        if (parentText.includes('google') || 
            parentText.includes('plaque') || 
            parentText.includes('entreprise') ||
            parentText.includes('recherchez')) {
          console.log('Found input by context');
          callback(input);
          return;
        }
      }
    }
    
    // Last resort - try to find the input field directly from the screenshot
    // From the screenshot we can see there's an input with "Tapez le nom de votre entreprise ici" placeholder
    console.log('Trying direct DOM traversal to find input');
    const possibleInputs = document.querySelectorAll('input[type="text"]');
    console.log(`Found ${possibleInputs.length} text inputs on the page`);
    
    // Look for the input field that appears after "Recherchez votre entreprise pour vous installer"
    const h3Elements = document.querySelectorAll('h3, h4, strong, b, .form-label');
    for (const h3 of h3Elements) {
      if (h3.textContent && h3.textContent.includes('Recherchez votre entreprise')) {
        console.log('Found heading with "Recherchez votre entreprise"');
        // Look for the next input field
        let element = h3.nextElementSibling;
        while (element) {
          const input = element.querySelector('input[type="text"]') || 
                       (element.tagName === 'INPUT' && element.type === 'text' ? element : null);
          if (input) {
            console.log('Found input field after heading');
            callback(input);
            return;
          }
          element = element.nextElementSibling;
        }
      }
    }
    
    // If still not found, set up an observer to watch for DOM changes
    console.log('Input not found immediately, setting up observer...');
    const observer = new MutationObserver(function(mutations) {
      // Check if Easify has added the input field
      for (const selector of selectors) {
        try {
          const input = document.querySelector(selector);
          if (input) {
            console.log(`Found input after DOM change with selector: ${selector}`);
            observer.disconnect();
            callback(input);
            return;
          }
        } catch (error) {
          // Ignore errors with selectors
        }
      }
    });
    
    // Start observing
    observer.observe(document.body, { childList: true, subtree: true });
    
    // Also try again after a delay
    setTimeout(function() {
      // Try one more time
      for (const selector of selectors) {
        try {
          const input = document.querySelector(selector);
          if (input) {
            console.log(`Found input after timeout with selector: ${selector}`);
            observer.disconnect();
            callback(input);
            return;
          }
        } catch (error) {
          // Ignore errors with selectors
        }
      }
      
      // If still not found, check if Easify is loaded in the window object
      if (window.EasifyProductOptions) {
        console.log('Easify detected in window object, trying to hook into it...');
        
        // Try to hook into Easify's rendering
        const originalRender = window.EasifyProductOptions.render;
        if (originalRender && typeof originalRender === 'function') {
          window.EasifyProductOptions.render = function(...args) {
            const result = originalRender.apply(this, args);
            
            // After rendering, try to find the input again
            setTimeout(function() {
              for (const selector of selectors) {
                try {
                  const input = document.querySelector(selector);
                  if (input) {
                    console.log(`Found input after Easify render with selector: ${selector}`);
                    observer.disconnect();
                    callback(input);
                    return;
                  }
                } catch (error) {
                  // Ignore errors with selectors
                }
              }
            }, 500);
            
            return result;
          };
        }
      }
      
      // If all else fails, we'll keep the observer running
    }, 1000);
  }
  
  // Check if we're on a product page with Google Plaques
  function isGooglePlaquesProduct() {
    // Check URL
    const url = window.location.pathname.toLowerCase();
    if (url.includes('google') && url.includes('plaque')) {
      return true;
    }
    
    // Check product title
    const productTitles = document.querySelectorAll('.product-title, .product__title, h1');
    for (const title of productTitles) {
      if (title.textContent.toLowerCase().includes('google') && 
          title.textContent.toLowerCase().includes('plaque')) {
        return true;
      }
    }
    
    // Check if Easify option exists
    const easifyOption = document.querySelector(
      `[data-option-id="${OPTION_ID}"], [data-option-set-id="${OPTION_ID}"]`
    );
    if (easifyOption) {
      return true;
    }
    
    return false;
  }
  
  // Direct approach to target the specific input field from the screenshot
  function directTargetInputField() {
    console.log('Using direct approach to target input field');
    
    try {
      // From your screenshot, we can see the exact input field
      // It's under a heading "Recherchez votre entreprise pour vous installer"
      // and has a "This is a required field" error message
      
      // Try to find the input directly
      const inputField = document.querySelector('input[placeholder="Tapez le nom de votre entreprise ici"]');
      if (inputField) {
        console.log('Found input directly by placeholder');
        if (window.google && window.google.maps && window.google.maps.places) {
          initializeGooglePlacesForInput(inputField);
        } else {
          loadGoogleMapsAPI();
        }
        return true;
      }
      
      // Try to find the input by its surrounding context
      // Find all elements that might contain the text
      const allElements = document.querySelectorAll('h1, h2, h3, h4, h5, h6, p, label, div, span');
      let heading = null;
      
      for (const element of allElements) {
        if (element.textContent && element.textContent.includes('Recherchez votre entreprise')) {
          heading = element;
          break;
        }
      }
      
      if (heading) {
        console.log('Found heading with "Recherchez votre entreprise"');
        // Find the closest input field
        let container = heading;
        // Try parent elements up to 3 levels
        for (let i = 0; i < 3; i++) {
          const input = container.querySelector('input[type="text"]');
          if (input) {
            console.log('Found input field near heading');
            if (window.google && window.google.maps && window.google.maps.places) {
              initializeGooglePlacesForInput(input);
            } else {
              loadGoogleMapsAPI();
            }
            return true;
          }
          // Try next sibling
          if (container.nextElementSibling) {
            const input = container.nextElementSibling.querySelector('input[type="text"]');
            if (input) {
              console.log('Found input field in next sibling');
              if (window.google && window.google.maps && window.google.maps.places) {
                initializeGooglePlacesForInput(input);
              } else {
                loadGoogleMapsAPI();
              }
              return true;
            }
          }
          container = container.parentElement;
          if (!container) break;
        }
      }
      
      // Try a more direct approach - from your screenshot, the input is visible
      // Look for any input field that might be for business search
      const errorMessages = document.querySelectorAll('.field-error, .error-message, [class*="error"], [class*="required"]');
      for (const errorMsg of errorMessages) {
        if (errorMsg.textContent && errorMsg.textContent.includes('required')) {
          console.log('Found error message about required field');
          const container = errorMsg.closest('div, form, section');
          if (container) {
            const input = container.querySelector('input[type="text"]');
            if (input) {
              console.log('Found input field near error message');
              if (window.google && window.google.maps && window.google.maps.places) {
                initializeGooglePlacesForInput(input);
              } else {
                loadGoogleMapsAPI();
              }
              return true;
            }
          }
        }
      }
    } catch (error) {
      console.error('Error in directTargetInputField:', error);
    }
    
    // Try direct approach with the input we can see in the screenshot
    const inputBySelector = document.querySelector('input[id*="option"], input[class*="option"], input[name*="option"]');
    if (inputBySelector) {
      console.log('Found input by selector pattern');
      if (window.google && window.google.maps && window.google.maps.places) {
        initializeGooglePlacesForInput(inputBySelector);
      } else {
        loadGoogleMapsAPI();
      }
      return true;
    }
    
    // If we can't find it directly, try the regular approach
    return false;
  }
  
  // Start the process when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      // Try direct approach first
      if (!directTargetInputField()) {
        // If direct approach fails, use the regular approach
        if (isGooglePlaquesProduct()) {
          loadGoogleMapsAPI();
        } else {
          console.log('Not a Google Plaques product page, skipping Google Places setup');
        }
      }
      
      // Also try again after a short delay
      setTimeout(function() {
        directTargetInputField();
      }, 1000);
    });
  } else {
    // DOM already loaded
    if (!directTargetInputField()) {
      // If direct approach fails, use the regular approach
      if (isGooglePlaquesProduct()) {
        loadGoogleMapsAPI();
      } else {
        console.log('Not a Google Plaques product page, skipping Google Places setup');
      }
    }
    
    // Also try again after a short delay
    setTimeout(function() {
      directTargetInputField();
    }, 1000);
  }
  
  // Also add a direct event listener to the document to catch when the input field appears
  document.addEventListener('input', function(event) {
    // Check if this is a text input that might be our target
    if (event.target.tagName === 'INPUT' && event.target.type === 'text') {
      const parent = event.target.closest('.product-form__item, .form-field, .option-wrapper, [class*="easify"]');
      if (parent && parent.textContent.toLowerCase().includes('entreprise')) {
        console.log('Found input field through input event');
        if (window.google && window.google.maps && window.google.maps.places) {
          initializeGooglePlacesForInput(event.target);
        } else {
          loadGoogleMapsAPI();
        }
      }
    }
  });
  
  // Direct DOM injection method - this is a last resort if nothing else works
  // We'll create a script that runs after a short delay and directly targets the input
  setTimeout(function() {
    console.log('Running direct DOM injection method');
    
    try {
      // Try to find the input field directly from the DOM structure in the screenshot
      const allInputs = document.querySelectorAll('input[type="text"]');
      console.log(`Found ${allInputs.length} text inputs on the page`);
      
      // Look for the input with the specific attributes or context
      for (const input of allInputs) {
        // Check if this input is under a container with "Recherchez votre entreprise"
        let parent = input.parentElement;
        let found = false;
        
        // Check up to 5 parent levels
        for (let i = 0; i < 5; i++) {
          if (!parent) break;
          
          if (parent.textContent && parent.textContent.includes('Recherchez votre entreprise')) {
            found = true;
            break;
          }
          
          parent = parent.parentElement;
        }
        
        if (found) {
          console.log('Found input through direct DOM traversal');
          // Set placeholder directly
          input.setAttribute('placeholder', 'Tapez le nom de votre entreprise ici');
          
          // Apply Google Places Autocomplete using our shared function
          if (window.google && window.google.maps && window.google.maps.places) {
            initializeGooglePlacesForInput(input);
            console.log('Applied Google Places Autocomplete through direct DOM injection');
          } else {
            // If Google API isn't loaded yet, we need to load it
            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&libraries=places&callback=initDirectPlacesAutocomplete`;
            script.async = true;
            script.defer = true;
            
            // Create a global callback function
            window.initDirectPlacesAutocomplete = function() {
              initializeGooglePlacesForInput(input);
              console.log('Applied Google Places Autocomplete through direct DOM injection callback');
            };
            
            document.head.appendChild(script);
          }
          
          break;
        }
      }
      
      // If we still haven't found the input, try a very direct approach
      // This is a last resort - directly inject the Google Places API into any text input on the page
      if (!window.googlePlacesApplied) {
        console.log('Trying emergency direct injection for any text input');
        
        // Get all text inputs
        const textInputs = document.querySelectorAll('input[type="text"]');
        
        // Find the most likely candidate - the one that's visible and not hidden
        for (const input of textInputs) {
          // Check if the input is visible
          const style = window.getComputedStyle(input);
          if (style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0') {
            console.log('Found visible text input for emergency injection:', input);
            
            // Apply Google Places Autocomplete
            if (window.google && window.google.maps && window.google.maps.places) {
              initializeGooglePlacesForInput(input);
              window.googlePlacesApplied = true;
              console.log('Applied emergency Google Places Autocomplete');
            } else {
              // Load Google Places API
              const script = document.createElement('script');
              script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&libraries=places&callback=initEmergencyPlacesAutocomplete`;
              script.async = true;
              script.defer = true;
              
              // Store the input in a global variable
              window.emergencyInput = input;
              
              // Create a global callback function
              window.initEmergencyPlacesAutocomplete = function() {
                initializeGooglePlacesForInput(window.emergencyInput);
                window.googlePlacesApplied = true;
                console.log('Applied emergency Google Places Autocomplete through callback');
              };
              
              document.head.appendChild(script);
            }
            
            break;
          }
        }
      }
    } catch (error) {
      console.error('Error in direct DOM injection method:', error);
    }
  }, 1500);
})();
